import * as React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useColorScheme } from '@mui/material/styles';
import MarketingPage from './components/MarketingPage';
import Privacy from './components/pages/Privacy';
import Terms from './components/pages/Terms';
import Contact from './components/pages/Contact';
import Imprint from './components/pages/Imprint';
import GenerateIdea from './components/pages/GenerateIdea';
import About from './components/pages/About';

export default function AppRouter() {
  const { mode, setMode } = useColorScheme();

  const toggleColorMode = () => {
    setMode(mode === 'dark' ? 'light' : 'dark');
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<MarketingPage mode={mode} toggleColorMode={toggleColorMode} />} />
        <Route path="/datenschutz" element={<Privacy mode={mode} toggleColorMode={toggleColorMode} />} />
        <Route path="/nutzungsbedingungen" element={<Terms mode={mode} toggleColorMode={toggleColorMode} />} />
        <Route path="/kontakt" element={<Contact mode={mode} toggleColorMode={toggleColorMode} />} />
        <Route path="/impressum" element={<Imprint mode={mode} toggleColorMode={toggleColorMode} />} />
        <Route path="/idee-generieren" element={<GenerateIdea mode={mode} toggleColorMode={toggleColorMode} />} />
        <Route path="/ueber-uns" element={<About mode={mode} toggleColorMode={toggleColorMode} />} />
      </Routes>
    </Router>
  );
}